<script setup>
import { ref } from 'vue'

defineProps({
  titulo: String,
  mostrarVolver: Boolean,
  textScale: Number,
  altoContraste: Boolean,
  ayudaTexto: String,
  mostrarCambiarVista: Boolean,
})

defineEmits(['volver', 'update:textScale', 'update:altoContraste', 'cambiar-vista'])

const AJUSTE = 0.1
const MIN = 1
const MAX = 2

const mostrarAyuda = ref(false)
</script>

<template>
  <header class="mayores-header">
    

    <div class="mayores-header__fila">
      <button
        v-if="mostrarVolver"
        type="button"
        class="mayores-header__boton"
        aria-label="Volver a la pantalla anterior"
        @click="$emit('volver')"
      >
        <i class="pi pi-arrow-left" aria-hidden="true" />
        <span>Volver</span>
      </button>

      <div class="mayores-header__espaciador" />

      
      <button
        type="button"
        class="mayores-header__boton mayores-header__texto"
        aria-label="Achicar el tamaño del texto"
        @click="$emit('update:textScale', Math.max(MIN, +(textScale - AJUSTE).toFixed(2)))"
      >A-</button>
      <button
        type="button"
        class="mayores-header__boton mayores-header__texto"
        aria-label="Agrandar el tamaño del texto"
        @click="$emit('update:textScale', Math.min(MAX, +(textScale + AJUSTE).toFixed(2)))"
      >A+</button>
     
    </div>

    
  </header>
</template>
